<template>
  <div class="hi-lo-card">
    <div class="hi-lo-deck">
      <div ref="hi-lo-hero-card" class="hi-lo-hero-card" :class="{ hidden: hidden }"></div>
      <div class="hi-lo-card-container" :class="{ 'flip-active': flip }">
        <div ref="card" class="card">
          <div class="count-up">
            <div class="count-up-sec">
              <div class="count-up-third">
                <div class="round-up">
                  <svg>
                    <circle r="12" cx="12.5" cy="16.5" :style="circleStyles" />
                  </svg>
                  {{ countDown }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref="card-back" class="card-back" :style="cardBackStyle"></div>
      </div>
    </div>

    <div v-if="fiveCard" class="hi-lo-five-card">
      <div
        :key="i"
        v-for="(item, i) in fiveCard.slice().reverse()"
        ref="fiveCard"
        :class="'hi-lo-five-card-container-' + i"
        :style="fiveCardStyle(item)"
      ></div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import { TweenLite, TimelineLite } from "gsap";
import { forEach } from "lodash";
// import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";
import EventBus from "../../../configs/event-bus";

export default {
  mixins: [betLotMixin],
  props: [
    "game",
    "winCellNo",
    "secondsString",
    "minutesString",
    "gameData",
    "showDrawingAnimation",
    "drawResult",
    "countDown"
  ],
  components: {
    Row,
    Col,
    Button
    // NewBetLot
  },
  data() {
    return {
      flip: false,
      hidden: true,
      fiveCard: []
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      let vm = this;
      if (newVal) {
        // console.log("Hilo show drawing");
        vm.flip = true;
        vm.hidden = false;
      }
    },
    drawResult(newVal, oldVal) {
      let vm = this;
      if (newVal && vm.flip) {
        // console.log(newVal);
        // console.log(vm.$refs);

        let heroCard = TweenLite.to(vm.$refs["hi-lo-hero-card"], 0.6, {
          // scale: 0.8,
          height: `${vm.$refs.fiveCard[4].offsetHeight}px`,
          width: `${vm.$refs.fiveCard[4].offsetWidth}px`,
          rotation: 360,
          top: `${vm.$refs.fiveCard[4].offsetTop - 15}px`,
          left: `${vm.$refs.fiveCard[4].offsetLeft - 5}px`,
          ease: Linear.easeNone
        });

        vm.$refs.fiveCard.forEach((el, i) => {
          if (i == 0) {
            TweenLite.to(el, 0.6, {
              left: `-22%`
            });
          } else {
            TweenLite.to(el, 0.6, {
              left: `-20%`
            });
          }
        });

        setTimeout(() => {
          vm.hidden = true;
          vm.flip = false;

          vm.$refs.fiveCard.forEach((el, i) => {
            TweenLite.to(el, 0, {
              left: `0%`
            });
          });

          vm.$refs[
            "card"
          ].style.backgroundImage = `url(${require(`../../../assets/images/hi-lo/${this
            .drawResult.draw_result + this.drawResult.draw_color}.png`)})`;

          vm.$refs[
            "hi-lo-hero-card"
          ].style.backgroundImage = `url(${require(`../../../assets/images/hi-lo/${this
            .drawResult.draw_result + this.drawResult.draw_color}.png`)})`;

          vm.fiveCard = this.drawResult.lastFive;
          TweenLite.fromTo(
            vm.$refs["hi-lo-hero-card"],
            0.5,
            {
              // scale: 0.8,
              height: `${vm.$refs.fiveCard[4].offsetHeight}px`,
              width: `${vm.$refs.fiveCard[4].offsetWidth}px`,
              top: `${vm.$refs.fiveCard[4].offsetTop - 5}px`,
              left: `${vm.$refs.fiveCard[4].offsetLeft - 5}px`,
              rotation: 360,
              ease: Linear.easeNone
            },
            {
              // scale: 1,
              rotation: 0,
              height: "94%",
              width: "100%",
              top: "0px",
              left: "0px",
              ease: Linear.easeNone,
              onComplete: function() {
                clearStakeRecord(vm.gameData.gID);
                EventBus.$emit("update-session-storage");
                vm.animationEnd();
              }
            }
          );
        }, 1000);
      }
    }
  },
  computed: {
    cardStyle() {
      return {
        "background-image": `url(${require(`../../../assets/images/hi-lo/${this
          .drawResult.last_result + this.drawResult.last_color}.png`)})`
      };
    },
    cardBackStyle() {
      return {
        "background-image": `url(${require(`../../../assets/images/hi-lo/Back.png`)})`,
        "background-color": "transparent"
      };
    },
    circleStyles() {
      return {
        "stroke-dasharray": "75px",
        "stroke-dashoffset": `${(this.countDown / this.gameData.fullInterval) *
          70}px`,

        transition: "stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease 0s"
      };
    },
    heroCard() {
      return {
        "background-image": `url(${require(`../../../assets/images/hi-lo/${this
          .gameData.last_result + this.gameData.last_color}.png`)})`
      };
    }
  },
  mounted() {
    this.fiveCard = this.gameData.lastFive;

    this.$refs[
      "hi-lo-hero-card"
    ].style.backgroundImage = `url(${require(`../../../assets/images/hi-lo/${this.gameData.last_result}${this.gameData.last_color}.png`)})`;
    this.$refs[
      "card"
    ].style.backgroundImage = `url(${require(`../../../assets/images/hi-lo/${this.gameData.last_result}${this.gameData.last_color}.png`)})`;
  },
  methods: {
    animationEnd() {
      this.$emit("on-animation-end");
    },
    fiveCardStyle(lastFive) {
      return {
        "background-image": `url(${require(`../../../assets/images/hi-lo/${lastFive}.png`)})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.hi-lo-card {
  display: flex;
  flex-direction: column;
  @extend .game-section;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.hi-lo-deck {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../../assets/images/hi-lo/cardDeck.png");
  margin-top: 10px;
}
.hi-lo-hero-card {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 94%;
  text-align: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../../assets/images/hi-lo/Back.png");
}
.hi-lo-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 94%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  z-index: 0;
}

.hi-lo-card-container.flip-active {
  transition: transform 0s;
}
.card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  // box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}
.card-back {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  // box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}
.flip-active {
  // display: none;
  transform: rotateY(180deg);
}
.card,
.card-back {
  position: absolute;

  backface-visibility: hidden;
}
.card-back {
  //  backface-visibility: visible;
  // background-color: white;
  transform: rotateY(180deg);
}
.count-up {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 45px;
  border-radius: 50%;
  background-color: #c1c1c1;
  border: 1px solid transparent;
}
.count-up-sec {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #858585;
  border: 1px solid transparent;
}
.count-up-third {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid transparent;
  background-color: #2a2a2a;
}
.round-up {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 31px;
  width: 31px;
  color: white;
  font-size: 12px;
  text-align: center;
}
.round-up svg {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  margin: -1px;
  top: 0;
  right: 0;
  width: 26px;
  height: 32px;
  transform: rotateZ(90deg) rotateZ(180deg);
}
.round-up svg circle {
  stroke-linecap: unset;

  stroke-width: 2px;
  stroke: #ff8a01;
  fill: none;
  //   animation: countdown 10s linear infinite forwards;
  //   -webkit-animation: countdown 10s linear infinite forwards;
  r: 12;
  cx: 12.5;
  cy: 16.5;
}

// @keyframes countdown  {
//   0% {
//     stroke-dashoffset: 0px;
//   }
//   100% {
//     stroke-dashoffset: 110px;
//   }
// }

.hi-lo-five-card {
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 80px;
}
.hi-lo-five-card-container,
.hi-lo-five-card-container-0,
.hi-lo-five-card-container-1,
.hi-lo-five-card-container-2,
.hi-lo-five-card-container-3,
.hi-lo-five-card-container-4 {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  // background-image: url("../../../assets/images/hi-lo/7B.png");
  position: relative;
}

.hi-lo-card-betlot {
  flex: 1;
  margin: 0 2px;
}

.hi-lo-card-betlot:first-of-type {
  margin-left: unset;
  //    background: linear-gradient(#c40000, #6e0000);
}

.hi-lo-card-betlot:last-of-type {
  margin-right: unset;
  //   background: linear-gradient(#393737, #040404);
}
.hidden {
  display: none;
}
</style>
